export default class {
    constructor ($) {
        this.$ = $;
    }

    loadSkin (skin) {
        const { $ } = this;
        const cssDom = $('#skinCss');
        if (skin !== cssDom.attr('data-skin')) {
            cssDom.attr('data-skin', skin);
            cssDom.attr(
                'href',
                `assets/css/${skin}/styles.min.css?v=${Math.random().toString(36).substring(7)}`
            );
        }
    }

    getCertificateImage (fileName, companyId) {
        return `${SEED_CORE.ENV.API_URL}certificateImages/${companyId}/thumbnails/companySettings/${fileName}`;
    }

    getLogoImage (fileName, companyId, thumbnailType) {
        return `${SEED_CORE.ENV.API_URL}companyLogos/${companyId}/thumbnails/${thumbnailType}/${fileName}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/company/index.js